<template>
  <div class="page">
    <h2>News</h2><br>
      <news-list
        :newsItemList="newsList"
      />
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import NewsList from '../components/news/NewsList'

export default {
  name: 'News',
  components: {
    NewsList,
  },
  data() {
      return {
      }
  },
  computed: {
      ...mapGetters([
        'newsList',
      ]),
  },
  methods: {
  },
  created() {
  }
}
</script>

<style scoped>
</style>
